<template>
	<svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25" class="check-icon" :class="classComputed">
		<g fill="none" fill-rule="evenodd">
			<g fill-rule="nonzero">
				<g transform="translate(-780.000000, -278.000000) translate(780.000000, 278.000000)">
					<circle cx="12.5" cy="12.5" r="12.5" />
					<g fill="#FFF">
						<path d="M10.811.938L4.807 6.835l-1.63-1.6c-.594-.585-1.557-.585-2.151 0-.594.583-.594 1.53 0 2.113l2.705 2.657c.298.292.687.438 1.076.438.39 0 .78-.146 1.076-.438l7.08-6.953c.595-.584.595-1.53 0-2.114-.594-.584-1.557-.584-2.152 0z" transform="translate(6.000000, 7.000000)"/>
					</g>
				</g>
			</g>
		</g>
	</svg>
</template>

<script>
export default {
	name: 'check-icon',
	props: ['selected', 'color'],
	computed: {
		classComputed() {
			return [
				this.color ? `check-icon-${this.color}` : '',
			];
		},
	},
};
</script>

<style lang="scss" scoped>
.check-icon {
	circle {
		fill: #D5D5D5;
	}
	&.check-icon-success {
		circle {
			fill: var(--app-color-success) !important;
		}
	}
	&.check-icon-primary {
		circle {
			fill: var(--app-color-primary) !important;
		}
	}
}
</style>



// WEBPACK FOOTER //
// src/modules/shared/components/icons/check-icon.vue